import common from '@page/common/js/common';
import useCorpPage from '@composable/useCorpPage';

const { corpPage } = useCorpPage();
corpPage();
